import React from "react";
import styled from "styled-components";

const Gallery = ({ 
  title = "Book A Space",
  subtitle = "Find the perfect workspace for your needs",
  items = [
    {
      title: "Hot Desks",
      description: "Perfect for our independent workers and small teams in an open area. Book below.",
      imageSrc: "/hotdesks.jpg /office_rental.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Meeting Rooms",
      description: "Suitable for presentations and meetings with your team and clients. Book below.",
      imageSrc: "/meeting_room.jpg office_rental.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Conference Rooms",
      description: "Available for live presentations and meetings on a larger scale. Book below.",
      imageSrc: "/conference_room.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Virtual Space",
      description: "Establish a professional presence without the cost of a physical workspace. Book below.",
      imageSrc: "/virtual_space.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Office Rental",
      description: "Perfect for established businesses needing privacy. Book below.",
      imageSrc: "/office_rental.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Suite Rental",
      description: "Professional private office suites designed to give your business a secure and flexible base. Book below.",
      imageSrc: "/suite_rental.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    }
  ]
}) => {
  // Function to handle smooth scrolling to the form
  const handleSmoothScroll = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <GallerySection>
      <GalleryHeader>
        <GalleryTitle>{title}</GalleryTitle>
        <GallerySubtitle>{subtitle}</GallerySubtitle>
      </GalleryHeader>
      
      <GalleryGrid>
        {items.map((item, index) => (
          <GalleryCard key={index}>
            <GalleryImageContainer>
              <GalleryImage src={item.imageSrc} alt={item.title} />
            </GalleryImageContainer>
            
            <GalleryContent>
              <GalleryCardTitle>{item.title}</GalleryCardTitle>
              <GalleryCardDescription>{item.description}</GalleryCardDescription>
              {/* <GalleryButton 
                href={item.ctaLink}
                onClick={(e) => handleSmoothScroll(e, item.ctaLink)}
              >
                {item.ctaText}
              </GalleryButton> */}
            </GalleryContent>
          </GalleryCard>
        ))}
      </GalleryGrid>
    </GallerySection>
  );
};

export default Gallery;

// Styled Components
const GallerySection = styled.section`
  padding: 80px 80px 80px 80px;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const GalleryHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
  padding: 0 20px;
`;

const GalleryTitle = styled.h2`
  font-size: 48px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const GallerySubtitle = styled.p`
  font-size: 20px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const GalleryCard = styled.div`
  background: white;
  border-radius: 25px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
`;

const GalleryImageContainer = styled.div`
  height: 250px;
  overflow: hidden;
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 25px 25px 25px 25px;
  transition: transform 0.5s ease;
`;

const GalleryContent = styled.div`
  padding: 30px 30px 30px 0px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 250px);
`;

const GalleryCardTitle = styled.h3`
  font-size: 24px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 15px;
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const GalleryCardDescription = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 25px;
  flex-grow: 1;
`;

const GalleryButton = styled.a`
  display: inline-block;
  background: #101015;
  width: 60%;
  color: white;
  padding: 24px 30px;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: #303035;
    color: #FFFFFF;
  }
`;